import { render, staticRenderFns } from "./CourseCardLearningTopics.vue?vue&type=template&id=cbbc42f2&scoped=true&"
import script from "./CourseCardLearningTopics.vue?vue&type=script&lang=js&"
export * from "./CourseCardLearningTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbc42f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListIcon: require('/builds/marketing/abstracta.academy-website/components/ListIcon.vue').default})
